import { type ReactElement } from "react";
import { skillsData, t } from "@/data";
import { SkillCard, Label } from "@/components";
import { useDarkMode, useLanguage } from "@/context";
import { useScrollReveal } from "@/hooks";

export const Skills = (): ReactElement => {
  const { modeClass } = useDarkMode();
  const { lang } = useLanguage();
  const { ref, revealed } = useScrollReveal<HTMLElement>();

  return (
    <section id="skills" ref={ref} className={`skills scroll-reveal${revealed ? " revealed" : ""} ${modeClass}`} aria-label={t(lang, "skillsSection")}>
      <div className="container">
        <Label text={t(lang, "skillsLabel")} labelType="open" modeClass={modeClass} />
        <div className="cards" role="list">
          {skillsData.map((skill, index) => (
            <div
              key={index}
              role="listitem"
              className={`skill-stagger${revealed ? " visible" : ""}`}
              style={{ transitionDelay: `${index * 40}ms` }}
            >
              <SkillCard
                title={skill.title}
                icon={skill.icon}
                width={100}
                height={100}
                fontWeight="bold"
              />
            </div>
          ))}
        </div>
        <Label text={t(lang, "skillsCloseLabel")} labelType="close" modeClass={modeClass} />
      </div>
    </section>
  );
};
